import {colorPrimitive} from '../../styles/primitives/colorPrimitive';

export interface InputSemanticStyles {
  default: string;
  hover: string;
  selected: string;

  filtered: string;
  filteredHover: string;

  error: string;
  errorHover: string;

  disabled: string;

  inverse: string;
  inverseHover: string;
}

export const lightInputSemanticStyles = {
  default: colorPrimitive.alpha.black.black100,
  hover: colorPrimitive.alpha.black.black200,
  selected: colorPrimitive.alpha.black.black300,

  filtered: colorPrimitive.blue[200],
  filteredHover: colorPrimitive.blue[300],

  error: colorPrimitive.red[200],
  errorHover: colorPrimitive.red[300],

  disabled: colorPrimitive.alpha.transparent,

  inverse: colorPrimitive.alpha.white.white500,
  inverseHover: colorPrimitive.alpha.white.white2000,
} as const satisfies InputSemanticStyles;

export const redesignedLightInputSemanticStyles = {
  ...lightInputSemanticStyles,

  filtered: colorPrimitive.blurple[200],
  filteredHover: colorPrimitive.blurple[300],
} as const satisfies InputSemanticStyles;

export const darkInputSemanticStyles = {
  default: colorPrimitive.alpha.white.white200,
  hover: colorPrimitive.alpha.white.white300,
  selected: colorPrimitive.alpha.white.white300,

  filtered: colorPrimitive.blue[900],
  filteredHover: colorPrimitive.blue[800],

  error: colorPrimitive.red[900],
  errorHover: colorPrimitive.red[800],

  disabled: colorPrimitive.alpha.transparent,

  inverse: colorPrimitive.alpha.white.white100,
  inverseHover: colorPrimitive.alpha.white.white200,
} as const satisfies InputSemanticStyles;

export const redesignedDarkInputSemanticStyles = {
  ...darkInputSemanticStyles,
  filtered: colorPrimitive.blurple[900],
  filteredHover: colorPrimitive.blurple[800],
} as const satisfies InputSemanticStyles;
